import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`mb-12`};
`

export const Description = styled.div`
  ${({ $isExpanded }) =>
    !$isExpanded && {
      display: '-webkit-box',
      '-webkit-line-clamp': '7',
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
    }};
`
